// extracted by mini-css-extract-plugin
export default {"container-header":"style_container-header__OGXg-","header_logo":"style_header_logo__y43ZQ","header__gap":"style_header__gap__Anaqb"};